import React from "react";
// import { Component } from "react";
// import { styled } from "styled-components"
import styled from "styled-components";
// import "./button.css"

const Button = styled.button`
  width: 142px;
  height: 46.16px;
  border: 0.1px solid silver;
  border-radius: 6px;
  margin: 0.5%;
  background-color: #f8f8f8;
`;
export default Button;
